<template>
    <div class="modal fade show" id="sleepData" tabindex="-1" role="dialog" aria-labelledby="sleepData" aria-hidden="true" style="display: block;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel">Blood Pressure</h4>
                    <button type="button" class="close" @click.prevent="$parent.toggleForm()">
                      <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <loader v-if="pageLoader"></loader>
                    <div class="Sleep_input">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="form-group field-wrapper">
                                <input type="number" class="float-field form-control" placeholder="BP Higher Level"  name="BP Higher Level" v-model="high" v-validate="'required|numeric'" />
                                <p class="error" v-if="submitted" v-for="error in errors.collect('BP Higher Level')">{{ error }}</p>
                            </div>
                            <div class="form-group field-wrapper">
                                <input type="number" class="float-field form-control" placeholder="BP Lower Level"  name="BP Lower Level" v-model="low" v-validate="'required|numeric'" />
                                <p class="error" v-if="submitted" v-for="error in errors.collect('BP Lower Level')">{{ error }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="form-group field-wrapper">
                        <input class="float-field form-control" type="time" :max="disableFutureTime" name="time" v-model="time" v-validate="'required'">
                        <p class="error" v-if="submitted && errors.has('time')">Time field is required </p>
                        <p class="error" v-if="submitted && selectFutureTime">Please Select time before current time</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default red" data-dismiss="modal" @click.prevent="$parent.toggleForm()">Close</button>
                    <button type="button" class="btn btn-default btn-blue" @click.prevent="AddBPData()">Save changes</button>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    import moment from 'moment'
    export default {
        name: "Blood-Pressure",
        props: ['from'],
        data() {
            return {
                pageLoader : false,
                submitted : false,
                high:'',
                low:'',
                time: '',
                disableFutureTime: moment().format("HH:mm"),
                selectFutureTime : false
            };
        },
        methods:{
            changeTime(){
                const d = new Date();
                if(this.time){
                    let hours = this.time.split(':')[0]
                    let minutes = this.time.split(':')[1]
                    if(this.from == '' || this.$parent.filter == 'today'){
                        d.setHours(parseInt(hours))
                        d.setMinutes(parseInt(minutes))
                    }else{
                        d.setDate(d.getDate()-1);
                        d.setHours(parseInt(hours))
                        d.setMinutes(parseInt(minutes))
                    }
                }
                return d
            },
            onFileChange(event){
                var fileData =  event;
                this.fileName = fileData.name;
            },
            AddBPData(){
                const _that = this
                let form_name = new FormData();
                _that.submitted = true;
                form_name.append("reading_time" , moment(_that.changeTime()).format('YYYY-MM-DD HH:mm'));
                form_name.append("high" , _that.high);
                form_name.append("low" , _that.low);
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        const d = new Date();
                        let hrs = this.time.split(':')[0]
                        let mns = this.time.split(':')[1]
                        d.setHours(parseInt(hrs))
                        d.setMinutes(parseInt(mns))
                        if(this.$parent.filter != 'yesterday' && moment(d).diff(moment(),'minutes') > 0){
                            this.selectFutureTime = true
                        }else{
                            this.selectFutureTime = false
                            let input_json = {
                                'globalParams' : {
                                    "form" : form_name,
                                },'localParams' : {'parameter' : _that, 'type' :'form'}
                            }
                            if(this.from){
                                input_json.localParams.from = this.from
                            }
                            this._runAddBloodPressure(input_json)
                        }
                    }
                }); 
            },
            reset(){
                this.submitted = false
                this.high = ''
                this.low = ''
                this.time = ''
                this.selectFutureTime = false
            }   
        },
        created(){
           this.pageName('Input Blood Pressure Data')
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/website/user/forms/BP-data.vue